import React, { useEffect } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import * as Icons from "react-feather";
import Center from "react-center";
import moment from "moment";
import bwipjs from "bwip-js";
import ReactToPdf from "react-to-pdf";

export default function SuccessPage(props) {
  const { successState, handleRegAgain } = props;
  const ref = React.createRef();

  useEffect(() => {
    if (successState?.nobooking) {
      let canvas = bwipjs.toCanvas("checkin", {
        bcid: "azteccode", // Barcode type
        text:
          // "http://192.168.10.194:1234/checkin/submit/" +
          successState?.nobooking, // Text to encode
        scale: 3, // 3x scaling factor
        // height: 10, // Bar height, in millimeters
        // includetext: true, // Show human-readable text
        textxalign: "center", // Always good to set this
      });
    }
  }, [successState]);

  const options = {
    orientation: "landscape",
    // unit: "in",
    // format: [4, 2],
    unit: "mm",
    format: [210, 297],
  };

  return (
    <>
      {!successState?.nobooking ? (
        <div style={{ textAlign: "center" }}>
          <h1>
            <strong>Terjadi Kesalahan, Pendaftaran Gagal.</strong>
          </h1>
        </div>
      ) : (
        <div
          ref={ref}
          style={{
            margin: "auto",
            width: "100%",
            padding: "10px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h1>
              <strong>Registrasi Online Berhasil</strong>
            </h1>
            <br />
            <canvas id="checkin"></canvas>
            {/* <Center>
          <QRCode
            value={
              "http://192.168.10.194:1234/checkin/submit/" +
              successState?.nobooking
            }
          />
        </Center> */}
            <br />
            <br />
            <h5>Nomor Booking: {successState?.nobooking}</h5>
            <h6>Nomor Antrian: {successState?.antrian}</h6>
            <h6>
              {moment(successState?.tanggal).format("DD/MM/YYYY") +
                " | " +
                successState?.jam}
            </h6>
          </div>
          <br />
          <Card>
            <Card.Body>
              <Row>
                <Col lg="12" md="12" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Nama Pasien</Form.Label>
                    <Form.Control
                      name="nama"
                      id="nama"
                      type="text"
                      value={successState?.nama_pasien}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4" md="4" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Tujuan</Form.Label>
                    <Form.Control
                      name="tujuan"
                      id="tujuan"
                      type="text"
                      value={successState?.sbuname}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4" md="4" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Unit</Form.Label>
                    <Form.Control
                      name="unit"
                      id="unit"
                      type="text"
                      value={successState?.unitname}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4" md="4" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Dokter</Form.Label>
                    <Form.Control
                      name="tujuan"
                      id="tujuan"
                      type="text"
                      value={successState?.doktername}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <span style={{ color: "#F57F17" }}>
            <strong>
              * Mohon Screenshot / Simpan tampilan ini agar memudahkan Klaim
              Registrasi Online Anda.
            </strong>
            {successState?.jaminan === "umum" && (
              <>
                <br />
                <strong>
                  * Untuk pasien Umum harap menyelesaikan Pembayaran
                  Administrasi Pendaftaran di Kasir.
                </strong>
              </>
            )}

            {successState.rs === "Belum" && (
              <>
                <br />
                <strong>
                  * Mohon Menuju Lobi Pendaftaran minimal satu jam sebelum
                  Antrian Poli, untuk melengkapi data rekam medis pasien baru
                  dengan membawa KTP pasien.
                </strong>
              </>
            )}
            {(successState.ramayanaNonPG === true ||
              successState?.jaminan === "bpjs") && (
              <>
                <br />
                <strong>
                  * Harap ke Lobby untuk melakukan pengecekan Administrasi.
                </strong>
              </>
            )}
            {successState?.jaminan === "lain" && (
              <>
                <br />
                <strong>
                  * Mohon ke lobby pendaftaran untuk melakukan verifikasi
                  administrasi.
                </strong>
              </>
            )}
            {successState?.sbuname === "Rumah Sakit Petrokimia Gresik" && (
              <>
                <br />
                <strong>* Mohon diisi survey kepuasan: </strong>
                <strong
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() =>
                    window.open("https://bit.ly/KepuasanPelangganRSPG")
                  }
                >
                  https://bit.ly/KepuasanPelangganRSPG
                </strong>
              </>
            )}
            {successState?.sbuname === "RSPG Driyorejo" && (
              <>
                <br />
                <strong>
                  * Mohon kirim kelengkapan berkas melalui Whatsapp ini:{" "}
                </strong>
                <strong
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => window.open("https://wa.me/6281235737711")}
                >
                  Kirim Disini
                </strong>
              </>
            )}
          </span>
        </div>
      )}
      <br />
      <br />
      <div className="d-grid gap-2">
        <ReactToPdf
          targetRef={ref}
          filename={successState?.nobooking + ".pdf"}
          options={options}
          x={0.0}
          y={0.0}
          scale={0.9}
        >
          {({ toPdf }) => (
            <Button
              variant="success"
              onClick={toPdf}
              block={true}
              style={{ width: "100%" }}
            >
              <Icons.FileText size={18} /> Download PDF
            </Button>
          )}
        </ReactToPdf>
        {/* <Button variant="secondary" onClick={() => handleRegAgain()}>
          Kembali
        </Button> */}
      </div>
    </>
  );
}
